import { ExternalLink } from "lucide-react";
import { isValidSharedConversationUrl } from "~/components/assistant/constants";
import { cn } from "~/lib/utils";

interface FeaturedConversationItemProps {
  label: string;
  url: string;
}

export function FeaturedConversationItem({ label, url }: FeaturedConversationItemProps) {
  const handleClick = () => {
    if (!isValidSharedConversationUrl(url)) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "group flex items-center gap-2 w-full px-2.5 py-1.5 text-[13px] cursor-pointer rounded",
        "hover:bg-gray-100 text-left"
      )}
      aria-label={`Open featured conversation: ${label}`}
    >
      <span className="truncate flex-1">{label}</span>
      <ExternalLink className="size-3.5 shrink-0 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity" />
    </button>
  );
}
